export default function(state = {}, action) {
  // NOTE: If I don't use action the reducer breaks. It's weird.
  // eslint-disable-next-line no-unused-vars
  const { type } = action;
  return state;
}
